import { render, staticRenderFns } from "./UkrTreasuresPayPalButtonsCreate.vue?vue&type=template&id=1ad9f184&scoped=true"
import script from "./UkrTreasuresPayPalButtonsCreate.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresPayPalButtonsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad9f184",
  null
  
)

export default component.exports